import { Persona } from "./types";

export function isSamePersona(
  left: Persona | null,
  right: Persona | null,
): boolean {
  if ((left?.type ?? null) !== (right?.type ?? null)) {
    return false;
  }
  return (left?.id ?? null) === (right?.id ?? null);
}
